import { PostCard } from 'components/PostCard';
import { MatchesCard } from 'components/MatchesCard';
import { Post } from 'lib/types';

interface Props {
  post: Post;
  isProfileOwner?: boolean;
  onPinChange?: () => void;
  showPin?: boolean;
  onIgnoreSuggestedCredit?: (postId: number) => void;
  showFavorite?: boolean;
  disableLinks?: boolean;
  mediaClassName?: string;
  fixedSize?: { width: number; height: number };
  /** The project ID the posts are associated with in the project context */
  projectId?: number;
  /** The project list ID the posts are associated with in the project context */
  projectListId?: number;
  /** The function to fetch data if needed */
  fetchData?: () => void;
  context?: 'profile';
  greyOutPosts?: boolean;
}

export const SinglePostResult = ({
  post,
  isProfileOwner,
  onPinChange,
  showPin = false,
  onIgnoreSuggestedCredit,
  showFavorite,
  disableLinks,
  mediaClassName,
  fixedSize,
  projectId,
  projectListId,
  fetchData,
  context,
  greyOutPosts,
}: Props) => {
  if (!post?.id) {
    return <></>;
  }
  const onFetchData = () => {
    onPinChange?.();
    fetchData?.();
  };

  if (post?.matchCount && post?.matchTotalCount && post?.matchId) {
    return (
      <div key={`match-pin-${post.id}-wrapper-${post.matchId}`} className={`${post.isFeatured && 'border-2 border-alpineTeal rounded-lg'}`}>
        <MatchesCard
          key={`match-pin-${post.id}-${post.matchId}`}
          post={post}
          matchCount={post.matchCount}
          matchTotalCount={post.matchTotalCount}
          matchId={post.matchId}
          fixedSize={fixedSize}
        >
          <PostCard
            key={`pin-${post.id}`}
            post={post}
            showPin={showPin}
            isProfileOwner={isProfileOwner}
            showMatchMetrics={post.matchCount > 1}
            projectId={projectId}
            projectListId={projectListId}
            fetchData={onFetchData}
            context={context}
            onIgnoreSuggestedCredit={onIgnoreSuggestedCredit}
            disableLinks={disableLinks}
            mediaClassName={mediaClassName}
            fixedSize={fixedSize}
            greyOutPosts={greyOutPosts}
            showFavorite={showFavorite}
          />
        </MatchesCard>
      </div>
    );
  }

  return (
    <div className={`mb-6 ${post.isFeatured && 'border-2 border-alpineTeal rounded-lg'}`} key={`pin-nonmatch-${post.id}-wrapper`}>
      <PostCard
        key={`pin-nonmatch-${post.id}`}
        post={post}
        showPin={showPin}
        isProfileOwner={isProfileOwner}
        fetchData={onFetchData}
        context={context}
        onIgnoreSuggestedCredit={onIgnoreSuggestedCredit}
        showFavorite={showFavorite}
        disableLinks={disableLinks}
        mediaClassName={mediaClassName}
        fixedSize={fixedSize}
        projectListId={projectListId}
        projectId={projectId}
        greyOutPosts={greyOutPosts}
      />
    </div>
  );
};
